
import individual from "../../../assets/icons/individual.svg";
import corporate from "../../../assets/icons/corporate.svg";
import ngo from "../../../assets/icons/NGO.svg";
import clickIcon from "../../../assets/icons/click.svg";

const SelectCampaign = ({ selectedCampaignType, onSelectCampaignType, onBlur}) => {
 
  const handleSelect = (campaignType) => {
    onSelectCampaignType(campaignType);
  };

  return (
    <div>
      <div>
        <div className="grid mb-8">
          <span className="font-semibold">Welcome to your campaign creator!</span>
          <span className="text-secondary text-sm">
            There are 5 crucial but short steps to get your campaign running.
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div
            onClick={() => handleSelect("CAMP002")}
            className={`bg-white p-4 rounded-md border cursor-pointer hover:shadow-sm ${
              selectedCampaignType === "CAMP002" ? "outline-brandGreen outline outline-[1.5px] shadow-xl" : ""
            }`}
            onBlur={onBlur}
          >
            <div className="flex justify-between items-center">
              <img src={individual} alt="" className="h-5" />
              <img src={clickIcon} alt="" className="h-5 opacity-30" />
            </div>
            <div className="mb-1 mt-4">Individuals</div>
            <div className="text-sm text-secondary">
              Create a personal campaign to support individuals in need, whether
              for medical expenses, education, or emergencies, and enable others
              to make a direct impact on their lives.
            </div>
          </div>
          <div
            onClick={() => handleSelect("CAMP001")}
            className={`bg-white p-4 rounded-md border cursor-pointer hover:shadow-sm ${
              selectedCampaignType === "CAMP001" ? "outline-brandGreen outline outline-[1.5px] shadow-xl" : ""
            }`}
            onBlur={onBlur}
          >
            <div className="flex justify-between items-center">
              <img src={corporate} alt="" className="h-5" />
              <img src={clickIcon} alt="" className="h-5 opacity-30" />
            </div>
            <div className="mb-1 mt-4">Corporate Organizations</div>
            <div className="text-sm text-secondary">
              Launch a corporate fundraising campaign to align your business with
              social responsibility goals and contribute to societal welfare,
              enhancing your brand's community connection.
            </div>
          </div>
          <div
            onClick={() => handleSelect("CAMP003")}
            className={`bg-white p-4 rounded-md border cursor-pointer hover:shadow-sm ${
              selectedCampaignType === "CAMP003" ? "outline-brandGreen outline outline-[1.5px] shadow-xl" : ""
            }`}
            onBlur={onBlur}
          >
            <div className="flex justify-between items-center">
              <img src={ngo} alt="" className="h-5" />
              <img src={clickIcon} alt="" className="h-5 opacity-30" />
            </div>
            <div className="mb-1 mt-4">NGOs</div>
            <div className="text-sm text-secondary">
              Set up a campaign for NGOs to expand their impact in areas like
              education and humanitarian aid, empowering your organization to
              address social issues and promote positive change.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCampaign;
